import { ProductModelsSections } from '../components/product/ProductModelsSections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildProductModelsPageSchema } from '../lib/schema';
import { PRODUCT_MODELS_META } from '../lib/seo';
import '../styles/product-landing.css';

export function ProductModelsPage() {
  return (
    <>
      <PageSeo meta={PRODUCT_MODELS_META} />
      <JsonLd data={buildProductModelsPageSchema()} />
      <MarketingLandingShell>
        <ProductModelsSections />
      </MarketingLandingShell>
    </>
  );
}
